import { LotInterface } from "@/types/LotInterface";
import { AuditLogInterface } from "../types/AuditLogInterface";
import { LotStatus } from "@/enums/LotStatus";

const calculateDaysOnHold = (
  lot: LotInterface,
  auditLogs: AuditLogInterface[]
) => {
  if (!auditLogs || !Array.isArray(auditLogs) || auditLogs.length === 0) {
    return 0;
  }

  const audits = auditLogs.filter((audit) => {
    if (!audit || audit.entityId !== lot._id) return false;

    const newChanges = audit.changes?.new as Record<string, string> | undefined;

    return newChanges?.status === LotStatus.HOLD;
  });

  if (audits.length === 0) return 0;

  const holdStartDate = new Date(audits[0].createdAt);
  const currentDate = new Date();
  const diffInMs = currentDate.getTime() - holdStartDate.getTime();
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  return diffInDays;
};

export default calculateDaysOnHold;
